module.exports = __webpack_public_path__ + "static/media/netfitnz_logo.e7cf3568.png";